<div class="contenedor-principal">
  <div>
    <div class="menu-content">
      <app-productos-sin-barra></app-productos-sin-barra>
    </div>
    <div class="menu-content">
      <h3>Categorias</h3>
      <div class="flex around-spacer wrap">
        <ng-container *ngFor="let categoria of categorias | async">
          <button
            *ngIf="categoria.pos"
            class="btn-menu"
            [routerLink]="['/venta/opciones/productos', categoria.nombre]"
          >
            {{ categoria.nombre }}
          </button>
        </ng-container>
      </div>
    </div>

    <div class="menu-content">
      <h3>Caja</h3>
      <div class="flex around-spacer">
        <button class="btn-menu" (click)="modalRemesas()">REMESAS</button>
        <button class="btn-menu" routerLink="/venta/opciones/egresos">
          SALIDAS
        </button>
        <button class="btn-cerrar" (click)="modalCerrarCaja()">
          CERRAR CAJA
        </button>
      </div>
    </div>

    <div class="menu-content">
      <h3>Recepcion</h3>
      <div class="flex around-spacer">
        <button class="btn-menu" routerLink="/recepcion">CREAR PRODUCTO</button>
        <button class="btn-menu" routerLink="/recepcion/libro-ventas">
          LIBRO DE VENTAS
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal remesas-->
<div
  class="modal fade"
  id="modalRemesas"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modelTitleId"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-producto-contenido">
        <form [formGroup]="remesaForm" class="flex center-center mb-1">
          <input
            type="text"
            formControlName="monto"
            class="input-producto-qty"
          />
        </form>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('7')">7</button>
          <button class="btn-numero" (click)="agregarDigito('8')">8</button>
          <button class="btn-numero" (click)="agregarDigito('9')">9</button>
        </div>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('4')">4</button>
          <button class="btn-numero" (click)="agregarDigito('5')">5</button>
          <button class="btn-numero" (click)="agregarDigito('6')">6</button>
        </div>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('1')">1</button>
          <button class="btn-numero" (click)="agregarDigito('2')">2</button>
          <button class="btn-numero" (click)="agregarDigito('3')">3</button>
        </div>

        <div class="row-numeros">
          <button class="btn-numero" (click)="agregarDigito('0')">0</button>
          <button class="btn-numero" (click)="agregarDigito('00')">00</button>
          <button class="btn-numero" (click)="borrarDigito()">
            <i class="fas fa-backspace"></i>
          </button>
        </div>

        <div class="seccion-botones">
          <button class="btn-aceptar" (click)="guardarRemesa()">ACEPTAR</button>
          <button class="btn-eliminar" (click)="cerrarModalRemesas()">
            CANCELAR
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Cerrar Caja-->
<div
  class="modal fade"
  id="modalCerrarCaja"
  tabindex="-1"
  role="dialog"
  aria-labelledby="modelTitleId"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <span style="font-size: 3em">
        Si cierra la caja, solo se puede volver abrir desde app movil. ¿Desea
        cerrar caja?
      </span>

      <div class="row">
        <div class="col-md-6">
          <button
            class="btn btn-success btn-block btn-lg"
            (click)="cerrarCaja()"
          >
            SI
          </button>
        </div>
        <div class="col-md-6">
          <button
            class="btn btn-danger btn-block btn-lg"
            (click)="cerrarModalCerrarCaja()"
          >
            NO
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
